import { Processes } from '../../common/types/types';
import { processesToProcessesTable } from '../../common/utils/HelperFunction';
import { ProcessesComponent } from '../../components/processes/ProcessesComponent';
import ProcessesService from '../../service/ProcessesService';
import { useAppDispatch } from '../../store/hooks/hooks';
import { setReachedProcesses } from '../../store/slice/ProcessesSlice';

export const ProcessesContainer = () => {
  const dispatch = useAppDispatch();
  ProcessesService.getProcesses().then((response) => {
    dispatch(setReachedProcesses(processesToProcessesTable(response.data as Array<Processes>)));
  });
  return <ProcessesComponent />;
};
